import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS } from '../../../config/navbarConfig';

const isPathActive = (pathname, path) => {
  if (path === '/') {
    return pathname === '/';
  }

  return pathname === path || pathname.startsWith(`${path}/`);
};

const isDropdownActive = (pathname, children = []) =>
  children.some((child) => isPathActive(pathname, child.path));

const NavMenu = ({ variant = 'desktop', onNavigate }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  const toggleDropdown = (labelKey) => {
    setOpenDropdown((current) => (current === labelKey ? null : labelKey));
  };

  const renderLink = (item, className = 'menu-item') => {
    const active = isPathActive(pathname, item.path);

    return (
      <li key={item.path} className={`${className}${active ? ' active' : ''}`}>
        <Link to={item.path} onClick={handleNavigate}>
          {t(item.labelKey)}
        </Link>
      </li>
    );
  };

  const renderDropdown = (item) => {
    const active = isDropdownActive(pathname, item.children);
    const isOpen = openDropdown === item.labelKey;

    if (variant === 'mobile') {
      return (
        <li
          key={item.labelKey}
          className={`menu-item menu-item-has-children${active ? ' active' : ''}${
            isOpen ? ' nav_open' : ''
          }`}
        >
          <button
            type="button"
            className="tps-navbar__mobile-dropdown-trigger"
            onClick={() => toggleDropdown(item.labelKey)}
            aria-expanded={isOpen}
          >
            <span>{t(item.labelKey)}</span>
            <i className="ion-arrow-right-b" aria-hidden="true" />
          </button>
          <ul className="sub-menu">
            {item.children.map((child) => {
              const childActive = isPathActive(pathname, child.path);

              return (
                <li
                  key={child.path}
                  className={`menu-item${childActive ? ' active' : ''}`}
                >
                  <Link to={child.path} onClick={handleNavigate}>
                    {t(child.labelKey)}
                  </Link>
                </li>
              );
            })}
          </ul>
        </li>
      );
    }

    return (
      <li
        key={item.labelKey}
        className={`menu-item menu-item-has-children${active ? ' active' : ''}`}
      >
        <a
          href="/"
          onClick={(event) => event.preventDefault()}
          aria-haspopup="true"
        >
          {t(item.labelKey)}
        </a>
        <ul className="sub-menu">
          {item.children.map((child) => {
            const childActive = isPathActive(pathname, child.path);

            return (
              <li
                key={child.path}
                className={`menu-item${childActive ? ' active' : ''}`}
              >
                <Link to={child.path} onClick={handleNavigate}>
                  {t(child.labelKey)}
                </Link>
              </li>
            );
          })}
        </ul>
      </li>
    );
  };

  return (
    <ul className={`main_menu tps-navbar__menu tps-navbar__menu--${variant}`}>
      {NAV_ITEMS.map((item) =>
        item.type === 'dropdown' ? renderDropdown(item) : renderLink(item)
      )}
    </ul>
  );
};

export default NavMenu;
